import { useEffect } from "react";
import { useEnvironment } from "@aviv-unified-frontend/runtime/environment";
import { createGlobalKey } from "@aviv-unified-frontend/internal";
import { BRAND_CONFIGURATION } from "../../../../configs/brands";
import { logger } from "../../../utils/logger";
import { useOverlayOrchestrator } from "../../OverlayOrchestrator";
import { isBannerOutdated } from "./isBannerOutdated";
const { appBanner } = BRAND_CONFIGURATION;
const { adjust } = appBanner ?? {};
const SMART_BANNER_STORAGE_KEY = createGlobalKey("smartBanner", "closingDate");
const useLoadAdjustBanner = () => {
    const { isWebView } = useEnvironment();
    const { dispatch } = useOverlayOrchestrator();
    useEffect(() => {
        const smartBannerClosingDate = window.localStorage.getItem(SMART_BANNER_STORAGE_KEY);
        if (isWebView ||
            !adjust ||
            (smartBannerClosingDate && !isBannerOutdated(smartBannerClosingDate))) {
            dispatch({ type: "DISABLE", payload: "adjust-banner" });
            return;
        }
        const initAdjustBanner = async () => {
            try {
                const AdjustSmartBanner = (await import("@adjustcom/smart-banner-sdk"))
                    .default;
                const { android, ios } = adjust;
                const bannerParent = document.querySelector("#shell_ufrn_layout__banner");
                const style = document.createElement("style");
                style.innerHTML = `
          #shell_ufrn_layout__banner:has(.small[class*="stickyToTop"]) {
            height: 80px;
          }

          #shell_ufrn_layout__banner:has(.medium[class*="stickyToTop"]) {
            height: 280px;
          }

          #shell_ufrn_layout__banner [class*="stickyToTop"] {
            position: fixed;
            z-index: 50;
          }

          #shell_ufrn_layout__banner [class*="stickyToBottom"] {
            position: fixed;
            bottom: 0;
            z-index: 50;
          }

          #shell_ufrn_layout__banner .large[class*="stickyToTop"] {
            bottom: 0;
            z-index: 50;
          }

          body:has(#shell_ufrn_layout__banner .large[class*="stickyToTop"]) {
            overflow: hidden;
          }
        `;
                AdjustSmartBanner.init({
                    logLevel: "verbose",
                    ...(bannerParent ? { bannerParent } : {}),
                    appToken: {
                        android,
                        ios,
                    },
                    onCreated: () => {
                        document.head.append(style);
                    },
                    onDismissed: () => {
                        window.localStorage.setItem(SMART_BANNER_STORAGE_KEY, `${Date.now()}`);
                        style.remove();
                    },
                });
                /**
                 * Mark the overlay as complete so that the next one in the queue can be displayed.
                 * As the Adjust banner does not block the UI, we consider it as completed once loaded.
                 */
                dispatch({ type: "COMPLETE", payload: "adjust-banner" });
            }
            catch (error) {
                dispatch({ type: "DISABLE", payload: "adjust-banner" });
                logger.error(`Adjust import has failed`, {
                    error,
                });
            }
        };
        initAdjustBanner();
    }, [isWebView, dispatch]);
};
export const AdjustBanner = () => {
    useLoadAdjustBanner();
    return null;
};
